import _ from 'underscore';
import stammdatenService from '../services/stammdatenService.js';
import systemNachrichtService from '../services/systemNachrichtService.js';
import basedataService from '../services/basedataService.js';
import { collectValues, displayValues, fuelleSelectOptionen, istEingeschraenkterSachbearbeiter, disableFormControls, resetDialogInput } from '../util.js';
import { updateDebounceUnternehmen } from './verwaltung.js';
import SystemDialogService from '../../../../shared/services/systemDialogService.js';
import schichtService from '../services/schichtService.js';

window.myHandlers = window.myHandlers || {};
window.myHandlers.selectPausenmodell = selectPausenmodell;
window.myHandlers.pausenmodellAddPause = pausenmodellAddPause;
window.myHandlers.pausenmodellRemovePause = pausenmodellRemovePause;
window.myHandlers.speicherePausenmodell = speicherePausenmodell;
window.myHandlers.erstellePausenmodell = erstellePausenmodell;
window.myHandlers.urlaubssperreNeu = urlaubssperreNeu;
window.myHandlers.confirmUrlaubssperreDialog = confirmUrlaubssperreDialog;
window.myHandlers.entferneUrlaubssperre = entferneUrlaubssperre;
window.myHandlers.updateE2NKey = updateE2NKey;
window.myHandlers.ladeBetriebE2N = ladeBetriebE2N;
window.myHandlers.importZeitenE2N = importZeitenE2N;
window.myHandlers.ladeBetriebCustomAPI = ladeBetriebCustomAPI;
window.myHandlers.updateCustomAPI = updateCustomAPI;
window.myHandlers.importZeitenCustomAPI = importZeitenCustomAPI;
window.myHandlers.speichereGZEinstellungen = speichereGZEinstellungen;
window.myHandlers.speichereUrlaubRundung = speichereUrlaubRundung;
window.myHandlers.uploadZeitenImportCSV = uploadZeitenImportCSV;
window.myHandlers.neueBeschaeftigungsartVorlage = neueBeschaeftigungsartVorlage;
window.myHandlers.bearbeiteBeschaeftigungsartVorlage = bearbeiteBeschaeftigungsartVorlage;
window.myHandlers.entferneBeschaeftigungsartVorlage = entferneBeschaeftigungsartVorlage;
window.myHandlers.waehleMustervorlageBAV = waehleMustervorlageBAV;
window.myHandlers.confirmBAVDialog = confirmBAVDialog;
window.myHandlers.updateBAVSollstundenMonat = updateBAVSollstundenMonat;
window.myHandlers.updateBAVSollstundenWoche = updateBAVSollstundenWoche;
window.myHandlers.updateBAVSollstundenTag = updateBAVSollstundenTag;
window.myHandlers.updateBAVSolltageWoche = updateBAVSolltageWoche;

async function ladeZeitregeln(unternehmen) {
	await ladePausenmodelle(unternehmen);
	await ladeUrlaubssperren(unternehmen);
	await ladeZeitenimport(unternehmen);
	await ladeBeschaeftigungsartVorlagen(unternehmen);
	displayValues(unternehmen, '', document.getElementById('u-Gutzeitregeln'), 'u-');
}

async function ladePausenmodelle(unternehmen) {
	const select = document.querySelector('[aria-label="u-input-Pausenmodelle"]');
	fuelleSelectOptionen(select, unternehmen.Pausenmodelle, '_id', 'Bezeichnung', true, 'Pausenmodell wählen');
	// wir wählen automatisch das erste Element aus, falls vorhanden.
	select.value = unternehmen.Pausenmodelle.length > 0 ? unternehmen.Pausenmodelle[0]._id : '';
	selectPausenmodell(select.value);
}

/**
 * Lädt das ausgewählte Pausenmodell in die Oberfläche.
 * @param {string} value ausgewähltes Pausenmodell (id)
 */
function selectPausenmodell(value) {
	// select auf übergebene value setzen, falls von außerhalb getriggert.
	document.querySelector('[aria-label="u-input-Pausenmodelle"]').value = value;
	const unternehmen = stammdatenService.unternehmen;
	const pausenModellFieldset = document.getElementById('u-Pausenmodelle');
	const selectedPausenmodell = unternehmen.Pausenmodelle.find((pm) => pm._id === value);
	const pausenListe = pausenModellFieldset.querySelector('#pausenmodell-pausen');
	[...pausenListe.querySelectorAll('.pausen-liste')].forEach((element) => element.remove());
	pausenModellFieldset.querySelector('[aria-label="u-input-pausen-Bezeichnung"]').value = '';
	if (!_.isEmpty(selectedPausenmodell)) {
		const template = document.querySelector('[u-input-pausen-template]');
		pausenModellFieldset.querySelector('[aria-label="u-input-pausen-Bezeichnung"]').value = selectedPausenmodell.Bezeichnung;
		selectedPausenmodell.Pausenstandard.forEach((pause) => {
			const newRow = template.content.cloneNode(true).children[0];
			displayValues(pause, '', newRow, 'u-input-pausen-');
			pausenListe.appendChild(newRow);
		});
	}
	// Eingeschränkte Sachbearbeiter dürfen Pausenmodelle nur ansehen, nicht bearbeiten. Da die
	// Pausenzeilen hier bei jedem Blättern neu erzeugt werden, muss das Sperren danach erfolgen.
	sperrePausenmodellBearbeitungFallsEingeschraenkt();
}

/**
 * Eingeschränkte Sachbearbeiter dürfen Pausenmodelle durchblättern, aber nicht ändern. Sperrt daher
 * alle Bearbeitungs-Controls im Pausenmodell-Fieldset; nur das Auswahl-Select zum Durchblättern
 * bleibt bedienbar. Für andere Benutzer ist die Funktion ein No-Op.
 */
function sperrePausenmodellBearbeitungFallsEingeschraenkt() {
	if (!istEingeschraenkterSachbearbeiter()) {
		return;
	}
	const fieldset = document.getElementById('u-pausenmodell-fieldset');
	if (!fieldset) {
		return;
	}
	disableFormControls(fieldset);
	// Auswahl-Select wieder aktivieren, damit weiterhin durchgeblättert werden kann.
	const auswahlSelect = fieldset.querySelector('[aria-label="u-input-Pausenmodelle"]');
	if (auswahlSelect) {
		auswahlSelect.disabled = false;
	}
	// "Pause entfernen"-Icons sind keine Form-Controls und werden daher separat ausgeblendet.
	fieldset.querySelectorAll('.pausen-remove').forEach((icon) => {
		icon.style.display = 'none';
	});
}

/**
 * Erstellt neue Zeile im Pausenmodell
 */
function pausenmodellAddPause() {
	const template = document.querySelector('[u-input-pausen-template]');
	const pausenListe = document.querySelector('#pausenmodell-pausen');
	const newRow = template.content.cloneNode(true).children[0];
	pausenListe.appendChild(newRow);
	setTimeout(() => newRow.querySelector('input').focus(), 100);
}

/**
 * Entfernt die ausgewählte Pause
 * @param {HTMLElement} thisElement Enternen Icon auf der Pausenzeile
 */
function pausenmodellRemovePause(thisElement) {
	// der Parent des Icons ist die Pausen Zeile, wir entfernen diese und speichern das Pausenmodell
	thisElement.parentNode.remove();
	speicherePausenmodell();
}

/**
 * Speichert das gewählte Pausenmodell im Unternehmen ab.
 */
async function speicherePausenmodell() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const pausenmodellSelect = document.querySelector('[aria-label="u-input-Pausenmodelle"]');
	if (_.isEmpty(pausenmodellSelect.value)) {
		return;
	}
	const pausenmodellSelection = unternehmen.Pausenmodelle.find((pm) => pm._id === pausenmodellSelect.value);
	if (_.isEmpty(pausenmodellSelection)) {
		systemNachrichtService.zeigeKleineNachricht('Pausenmodell nicht im Unternehmen gefunden!', -1);
		return;
	}
	// Speichere Inputdaten ins Pausenmodell
	pausenmodellSelection.Bezeichnung = document.querySelector('[aria-label="u-input-pausen-Bezeichnung"]').value;
	// Update der Bezeichnung im Select.
	pausenmodellSelect.options[pausenmodellSelect.selectedIndex].innerText = pausenmodellSelection.Bezeichnung;
	const pausenHTML = document.querySelectorAll('.pausen-liste');
	const pausenStandardNeu = [];
	pausenHTML.forEach((pause) => {
		const pauseObject = {
			Nach: '',
			Dauer: 0,
			Bezahlt: false,
			Raucherpause: false
		};
		collectValues(pauseObject, 'u-input-pausen-', pause);
		pausenStandardNeu.push(pauseObject);
	});
	pausenmodellSelection.Pausenstandard = pausenStandardNeu;
	updateDebounceUnternehmen(unternehmen);
}

/**
 * Event Handler für den "neu erstellen" Button bei den Pausenmodellen.
 */
async function erstellePausenmodell() {
	const pausenmodellNeu = {};
	const selectedPausenmodell = document.querySelector('[aria-label="u-input-Pausenmodelle"]').value;
	// Speichere Inputdaten ins Pausenmodell
	pausenmodellNeu.Bezeichnung = document.querySelector('[aria-label="u-input-pausen-Bezeichnung"]').value;
	// Falls wir aus einer anderen Pausenmodell erstellen, übernehmen wir den Namen mit Kopie
	if (selectedPausenmodell !== '') {
		pausenmodellNeu.Bezeichnung += ' (Kopie)';
	}
	const pausenHTML = document.querySelectorAll('.pausen-liste');
	const pausenStandardNeu = [];
	pausenHTML.forEach((pause) => {
		const pauseObject = {
			Nach: '',
			Dauer: 0,
			Bezahlt: false,
			Raucherpause: false,
		};
		collectValues(pauseObject, 'u-input-pausen-', pause);
		pausenStandardNeu.push(pauseObject);
	});
	pausenmodellNeu.Pausenstandard = pausenStandardNeu;
	if (pausenmodellNeu.Bezeichnung === '') {
		pausenmodellNeu.Bezeichnung = 'unbenannt';
	}
	const result = await stammdatenService.erstellePausenmodell(pausenmodellNeu);
	// Abbruch bei fehlerhafter Antwort.
	if (_.isEmpty(result)) {
		return;
	}
	// Falls der Vorgang erfolgreich ist, müssen wir das neue Pausenmodell im Select aufnehmen.
	await ladePausenmodelle(stammdatenService.unternehmensobjekt);
	selectPausenmodell(result);
}

/**
 * Erstellt neue Urlaubssperre Dialog
 */
async function urlaubssperreNeu() {
	const dialog = document.getElementById('u-urlaubssperre-dialog');
	const unternehmen = stammdatenService.unternehmensobjekt;
	const betriebSelect = dialog.querySelector('#u-urlaubssperre-betrieb');
	const bereichSelect = dialog.querySelector('#u-urlaubssperre-bereich');
	// inaktive Betriebe ausblenden
	const betriebeAktiv = unternehmen.Betriebsstaette.filter((betrieb) => betrieb.Aktiv);
	fuelleSelectOptionen(betriebSelect, betriebeAktiv, '_id', 'BetriebsstaetteName', true, 'alle', 'alle');
	// inaktive Bereiche ausblenden
	const bereicheAktiv = unternehmen.Bereiche.filter((bereich) => bereich.Verwenden);
	fuelleSelectOptionen(bereichSelect, bereicheAktiv, '_id', 'Bereich', true, 'alle', 'alle');
	const response = await SystemDialogService.instance.displayAsync('u-urlaubssperre-dialog');
	if (response.success) {
		await stammdatenService.neueUrlaubssperre(response.data);
		await ladeUrlaubssperren(stammdatenService.unternehmensobjekt);
	}
}

function confirmUrlaubssperreDialog() {
	const dialog = document.getElementById('u-urlaubssperre-dialog');
	if (![...dialog.querySelectorAll('input')].every((input) => input.checkValidity())) {
		return systemNachrichtService.zeigeKleineNachricht('Bitte alle Felder ausfüllen!');
	}
	const bereichSelect = dialog.querySelector('#u-urlaubssperre-bereich');
	const betriebSelect = dialog.querySelector('#u-urlaubssperre-betrieb');
	SystemDialogService.instance.confirm({
		Titel: dialog.querySelector('#u-urlaubssperre-titel').value,
		Bereich: bereichSelect.options[bereichSelect.selectedIndex].text,
		Betrieb: betriebSelect.options[betriebSelect.selectedIndex].text,
		BereichID: bereichSelect.value,
		BetriebID: betriebSelect.value,
		UrlaubssperreVon: dialog.querySelector('#u-urlaubssperre-datum-von').value,
		UrlaubssperreBis: dialog.querySelector('#u-urlaubssperre-datum-bis').value,
	});
}

/**
 * Rendert Urlaubssperren
 */
async function ladeUrlaubssperren(unternehmen) {
	const urlaubssperren = unternehmen?.Urlaubssperren;
	if (!urlaubssperren) return;
	document.getElementById('u-urlaubssperre-leer').style.display = urlaubssperren.length === 0 ? '' : 'none';
	const template = document.querySelector('[u-urlaubssperre-template]');
	const sperrListe = document.querySelector('#u-urlaubssperre-list');
	sperrListe.innerHTML = '';
	urlaubssperren.forEach((us) => {
		const newRow = template.content.cloneNode(true).children[0];
		newRow.id = us._id;
		displayValues(us, '', newRow, 'u-urlaubssperre-');
		sperrListe.appendChild(newRow);
	});
}

async function entferneUrlaubssperre(thisElement) {
	const urlaubsperreID = thisElement.closest('.u-urlaubssperre-item').id;
	await stammdatenService.entferneUrlaubssperre(urlaubsperreID);
	await ladeUrlaubssperren(stammdatenService.unternehmensobjekt);
}


async function ladeZeitenimport(unternehmen) {
	const selectE2N = document.getElementById('u-e2n-betrieb');
	const selectAPI = document.getElementById('u-api-betrieb');
	[selectE2N, selectAPI].forEach((select) => {
		let aktuelleBS = select.value;
		// Nur ausfüllen falls nicht vorhanden
		if (select.children.length <= 0 || select.value == '') {
			const aktiveBS = unternehmen.Betriebsstaette.filter((bs) => bs.Aktiv === true);
			aktiveBS.forEach((bs) => {
				const option = document.createElement('option');
				option.innerText = bs.BetriebsstaetteName;
				option.value = bs._id;
				select.appendChild(option);
			});
			aktuelleBS = stammdatenService.aktuelleBetriebsstaette ? stammdatenService.aktuelleBetriebsstaette : aktiveBS[0]._id;
			select.value = aktuelleBS;
		}
	});
	await ladeBetriebE2N();
	await ladeBetriebCustomAPI();
}

async function ladeBetriebE2N() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const betriebSelection = document.getElementById('u-e2n-betrieb');
	if (!betriebSelection.value) betriebSelection.value = stammdatenService.aktuelleBetriebsstaette;
	const betrieb = unternehmen.Betriebsstaette.find((b) => _.isEqual(b._id, betriebSelection.value));
	if (!betrieb) return systemNachrichtService.zeigeKleineNachricht('Kein Betrieb gefunden!', -1);
	const e2nKey = betrieb?.Zeitenimport?.e2nAPIKey;
	document.body.querySelector('[aria-label="u-e2nAPIKey"]').value = e2nKey ? e2nKey : '';
	if (e2nKey) {
		document.getElementById('u-e2n-import-zeitraum').value = window.myVars.aktuellesMonatsDatum.format('YYYY-MM');
		document.getElementById('u-e2n-import-btn').disabled = false;
		document.getElementById('u-e2n-import-zeitraum').disabled = false;
	} else {
		document.getElementById('u-e2n-import-btn').disabled = true;
		document.getElementById('u-e2n-import-zeitraum').disabled = true;
	}
}

async function updateE2NKey(thisElement) {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const select = document.getElementById('u-e2n-betrieb');
	const betrieb = unternehmen.Betriebsstaette.find((b) => _.isEqual(b._id, select.value));
	betrieb.Zeitenimport.e2nAPIKey = thisElement.value;
	updateDebounceUnternehmen(unternehmen);
	await ladeZeitenimport(unternehmen);
}

async function importZeitenE2N() {
	const select = document.getElementById('u-e2n-betrieb');
	const betriebID = select.value;
	const zeitraum = document.getElementById('u-e2n-import-zeitraum').value;
	if (!zeitraum) return systemNachrichtService.zeigeKleineNachricht('Bitte Zeitraum auswählen!', 0);
	await schichtService.importiereZeitenE2N(zeitraum, betriebID);
}

async function ladeBetriebCustomAPI(thisElement) {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const betriebSelection = document.getElementById('u-api-betrieb');
	if (!betriebSelection.value) betriebSelection.value = stammdatenService.aktuelleBetriebsstaette;
	const betrieb = unternehmen.Betriebsstaette.find((b) => _.isEqual(b._id, betriebSelection.value));
	if (!betrieb) return systemNachrichtService.zeigeKleineNachricht('Kein Betrieb gefunden!', -1);
	const route = betrieb?.Zeitenimport?.CustomAPIRoute;
	document.body.querySelector('[aria-label="u-CustomAPIRoute"]').value = route;
	document.body.querySelector('[aria-label="u-CustomXAPIKey"]').value =  betrieb?.Zeitenimport?.CustomXAPIKey;
	document.body.querySelector('[aria-label="u-CustomAuthToken"]').value =  betrieb?.Zeitenimport?.CustomAuthToken;
	if (route) {
		document.getElementById('u-api-import-zeitraum').value = window.myVars.aktuellesMonatsDatum.format('YYYY-MM');
		document.getElementById('u-api-import-btn').disabled = false;
		document.getElementById('u-api-import-zeitraum').disabled = false;
	} else {
		document.getElementById('u-api-import-btn').disabled = true;
		document.getElementById('u-api-import-zeitraum').disabled = true;
	}
}

async function updateCustomAPI() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const select = document.getElementById('u-api-betrieb');
	const betrieb = unternehmen.Betriebsstaette.find((b) => _.isEqual(b._id, select.value));
	if (!betrieb) return systemNachrichtService.zeigeKleineNachricht('Kein Betrieb gefunden!', -1);
	// Custom API Felder Values sammeln
	betrieb.Zeitenimport.CustomAuthToken = document.body.querySelector('[aria-label="u-CustomAuthToken"]').value;
	betrieb.Zeitenimport.CustomXAPIKey = document.body.querySelector('[aria-label="u-CustomXAPIKey"]').value;
	betrieb.Zeitenimport.CustomAPIRoute = document.body.querySelector('[aria-label="u-CustomAPIRoute"]').value;
	updateDebounceUnternehmen(unternehmen);
	await ladeZeitenimport(unternehmen);
}

async function importZeitenCustomAPI() {
	const select = document.getElementById('u-api-betrieb');
	const betriebID = select.value;
	const zeitraum = document.getElementById('u-api-import-zeitraum').value;
	if (!zeitraum) return systemNachrichtService.zeigeKleineNachricht('Bitte Zeitraum auswählen!', 0);
	const pausenmodellSelect = document.getElementById('u-csv-zeiten-import-pausenmodell');
	const unternehmen = stammdatenService.unternehmensobjekt;
	fuelleSelectOptionen(pausenmodellSelect , unternehmen.Pausenmodelle, '_id', 'Bezeichnung', true, 'Kein Pausenmodell anwenden');
	const optionMA = document.createElement('option');
	optionMA.value = 'mitarbeiter';
	optionMA.innerText = 'Pausenmodell des Mitarbeiters anwenden';
	pausenmodellSelect.add(optionMA, pausenmodellSelect.options[1]);
	const result = await SystemDialogService.instance.displayAsync('u-csv-zeiten-import-dialog');
	if (!result.success) return;
	const pausenmodell = result.data.Pausenmodell;
	await schichtService.importiereZeitenCustomAPI(zeitraum, betriebID, pausenmodell);
}

async function speichereGZEinstellungen() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const panelEinstellungen = document.getElementById('u-Gutzeitregeln');
	collectValues(unternehmen, 'u-', panelEinstellungen);
	updateDebounceUnternehmen(unternehmen);
}

/**
 * Speichert die gewählte Urlaubsrundung und berechnet den Urlaubsanspruch aller aktiven Mitarbeiter neu.
 */
async function speichereUrlaubRundung() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	unternehmen.UrlaubRundung = document.querySelector('[aria-label="u-UrlaubRundung"]').value;
	// Direkt speichern (kein Debounce), damit die Neuberechnung die neue Einstellung verwendet.
	await stammdatenService.updateUnternehmensdaten(unternehmen);
	await stammdatenService.berechneUrlaubsanspruchNeu();
}

async function uploadZeitenImportCSV(thisElement) {
	const inputForm = thisElement.closest('form');
    const file = new FormData(inputForm);
    const allowedDataFormats = [
        'text/plain',
        'text/csv',
    ];
    if (!allowedDataFormats.includes(file.get('file-upload').type)) {
        systemNachrichtService.zeigeKleineNachricht('Nur .txt und .csv Dateien sind erlaubt!');
        return;
    }
	const pausenmodellSelect = document.getElementById('u-csv-zeiten-import-pausenmodell');
	const unternehmen = stammdatenService.unternehmensobjekt;
	fuelleSelectOptionen(pausenmodellSelect , unternehmen.Pausenmodelle, '_id', 'Bezeichnung', true, 'Kein Pausenmodell anwenden');
	const optionMA = document.createElement('option');
	optionMA.value = 'mitarbeiter';
	optionMA.innerText = 'Pausenmodell des Mitarbeiters anwenden';
	pausenmodellSelect.add(optionMA, pausenmodellSelect.options[1]);
	const result = await SystemDialogService.instance.displayAsync('u-csv-zeiten-import-dialog');
	if (!result.success) return;
	if (thisElement.files[0].size / 1024 > 25) {
		systemNachrichtService.zeigeKleineNachricht('Dieser Vorgang kann einige Sekunden dauern...');
	}
	const pausenmodell = result.data.Pausenmodell;
	await schichtService.importiereZeitenCSV(file, pausenmodell);
	// reset data input
	thisElement.value = '';
}

/**
 * Rendert die Liste der unternehmenseigenen Beschäftigungsart Vorlagen.
 */
async function ladeBeschaeftigungsartVorlagen(unternehmen) {
	const liste = document.getElementById('u-bav-liste');
	liste.innerHTML = '';
	const eigeneVorlagen = unternehmen.BeschaeftigungsartVorlagen ?? [];
	document.getElementById('u-bav-leer').style.display = eigeneVorlagen.length === 0 ? '' : 'none';
	const template = document.querySelector('[u-bav-template]');
	eigeneVorlagen.forEach((vorlage) => {
		const newRow = template.content.cloneNode(true).children[0];
		newRow.id = vorlage._id;
		displayValues(vorlage, '', newRow, 'u-bav-');
		liste.appendChild(newRow);
	});
}

/**
 * Blendet die Eingabefelder des Beschäftigungsart Vorlage Dialogs ein/aus.
 * Beim Erstellen sollen diese erst nach Auswahl einer Mustervorlage sichtbar werden,
 * damit deutlich wird, dass diese Auswahl zwingend zuerst erfolgen muss.
 * @param {boolean} sichtbar
 */
function toggleBAVFelderSichtbar(sichtbar) {
	document.getElementById('u-bav-felder').style.display = sichtbar ? 'contents' : 'none';
	document.getElementById('u-bav-hinweis').style.display = sichtbar ? 'none' : 'flex';
}

/**
 * Event Handler für den "neu erstellen" Button bei den Beschäftigungsart Vorlagen.
 * Öffnet den Dialog im "Erstellen" Modus, mit einer Auswahl der Mustervorlagen des Basedataproviders.
 */
async function neueBeschaeftigungsartVorlage() {
	resetDialogInput('u-bav-dialog');
	document.getElementById('u-bav-mustervorlage-p').style.display = '';
	toggleBAVFelderSichtbar(false);
	const mustervorlageSelect = document.getElementById('u-bav-mustervorlage');
	const beschaeftigungenBDP = await basedataService.holeBeschaeftigungsartenBasedataProvider();
	fuelleSelectOptionen(mustervorlageSelect, beschaeftigungenBDP, 'BeschID', ['BeschaeftigungsartKurz', 'Personengruppenschluessel'], true, 'bitte wählen', '');
	const result = await SystemDialogService.instance.displayAsync('u-bav-dialog');
	if (!result.success) return;
	if (_.isEmpty(result.data.BeschID)) {
		systemNachrichtService.zeigeKleineNachricht('Bitte eine Mustervorlage wählen!');
		return;
	}
	const neueVorlageID = await stammdatenService.erstelleBeschaeftigungsartVorlage(result.data);
	if (!neueVorlageID) return;
	await ladeBeschaeftigungsartVorlagen(stammdatenService.unternehmensobjekt);
}

/**
 * Prefüllt den Dialog mit den Werten der ausgewählten Mustervorlage und blendet die restlichen Felder ein.
 * Bei Zurücksetzen auf "bitte wählen" werden die Felder wieder ausgeblendet und geleert.
 * @param {HTMLElement} thisElement Mustervorlagen Select
 */
async function waehleMustervorlageBAV(thisElement) {
	if (_.isEmpty(thisElement.value)) {
		resetDialogInput('u-bav-dialog');
		toggleBAVFelderSichtbar(false);
		return;
	}
	const beschaeftigungenBDP = await basedataService.holeBeschaeftigungsartenBasedataProvider();
	const mustervorlage = beschaeftigungenBDP.find((b) => b.BeschID === thisElement.value);
	if (_.isEmpty(mustervorlage)) return;
	displayValues(mustervorlage, '', document.getElementById('u-bav-dialog'), 'u-bav-');
	document.getElementById('u-bav-beschaeftigungsart-name').value = mustervorlage.BeschaeftigungsartKurz;
	toggleBAVFelderSichtbar(true);
}

/**
 * Event Handler für den "bearbeiten" Klick einer bestehenden Beschäftigungsart Vorlage.
 * Öffnet den Dialog im "Bearbeiten" Modus, ohne Mustervorlagenauswahl.
 * @param {HTMLElement} thisElement bearbeiten Icon der Vorlagenzeile
 */
async function bearbeiteBeschaeftigungsartVorlage(thisElement) {
	const vorlageID = thisElement.closest('.u-bav-item').id;
	const unternehmen = stammdatenService.unternehmensobjekt;
	const vorlage = unternehmen.BeschaeftigungsartVorlagen.find((v) => v._id === vorlageID);
	if (_.isEmpty(vorlage)) {
		systemNachrichtService.zeigeKleineNachricht('Beschäftigungsart Vorlage nicht gefunden!', -1);
		return;
	}
	resetDialogInput('u-bav-dialog');
	document.getElementById('u-bav-mustervorlage-p').style.display = 'none';
	toggleBAVFelderSichtbar(true);
	displayValues(vorlage, '', document.getElementById('u-bav-dialog'), 'u-bav-');
	const beschaeftigungenBDP = await basedataService.holeBeschaeftigungsartenBasedataProvider();
	const mustervorlage = beschaeftigungenBDP.find((b) => b.BeschID === vorlage.BeschID);
	document.getElementById('u-bav-beschaeftigungsart-name').value = mustervorlage?.BeschaeftigungsartKurz ?? '';
	const result = await SystemDialogService.instance.displayAsync('u-bav-dialog');
	if (!result.success) return;
	const updateSuccess = await stammdatenService.updateBeschaeftigungsartVorlage(vorlageID, result.data);
	if (!updateSuccess) return;
	await ladeBeschaeftigungsartVorlagen(stammdatenService.unternehmensobjekt);
}

/**
 * Event Handler für den "entfernen" Klick einer bestehenden Beschäftigungsart Vorlage.
 * @param {HTMLElement} thisElement entfernen Icon der Vorlagenzeile
 */
async function entferneBeschaeftigungsartVorlage(thisElement) {
	const vorlageID = thisElement.closest('.u-bav-item').id;
	const input = await SystemDialogService.instance.displayAsync('u-bav-delete-dialog');
	if (!input.success) return;
	const result = await stammdatenService.entferneBeschaeftigungsartVorlage(vorlageID);
	if (!result) return;
	await ladeBeschaeftigungsartVorlagen(stammdatenService.unternehmensobjekt);
}

/**
 * Sammelt die editierbaren Felder des Beschäftigungsart Vorlage Dialogs und bestätigt diesen.
 */
function confirmBAVDialog() {
	const dialog = document.getElementById('u-bav-dialog');
	const data = {
		BeschID: dialog.querySelector('[aria-label="u-bav-BeschID"]').value,
		BeschaeftigungsartKurz: '',
		SollstundenMonat: 0,
		SollstundenWoche: 0,
		SollstundenTag: 0,
		SolltageWoche: 0,
	};
	collectValues(data, 'u-bav-', dialog);
	if (_.isEmpty(data.BeschaeftigungsartKurz)) {
		systemNachrichtService.zeigeKleineNachricht('Bitte eine Kurzbezeichnung angeben!');
		return;
	}
	SystemDialogService.instance.confirm(data);
}

/**
 * Sollstunden Monat/Woche/Tag und Solltage Woche sind voneinander abhängig und müssen bei Eingabe neu berechnet werden
 * (analog zu ma_beschaeftigung.js).
 */
function updateBAVSollstundenMonat(thisElement) {
	const dialog = document.getElementById('u-bav-dialog');
	const solltageWoche = parseFloat(dialog.querySelector('[aria-label="u-bav-SolltageWoche"]').value);
	const sollstundenMonat = parseFloat(thisElement.value);
	const sollstundenWoche = Math.round((sollstundenMonat / 4.35) * 100) / 100;
	dialog.querySelector('[aria-label="u-bav-SollstundenWoche"]').value = sollstundenWoche;
	if (solltageWoche > 0) {
		const sollstundenTag = Math.round((sollstundenWoche / solltageWoche) * 100) / 100;
		dialog.querySelector('[aria-label="u-bav-SollstundenTag"]').value = sollstundenTag;
	}
}

function updateBAVSollstundenWoche(thisElement) {
	const dialog = document.getElementById('u-bav-dialog');
	const solltageWoche = parseFloat(dialog.querySelector('[aria-label="u-bav-SolltageWoche"]').value);
	const sollstundenWoche = parseFloat(thisElement.value);
	const sollstundenMonat = Math.round((sollstundenWoche * 4.35) * 100) / 100;
	dialog.querySelector('[aria-label="u-bav-SollstundenMonat"]').value = sollstundenMonat;
	if (solltageWoche > 0) {
		const sollstundenTag = Math.round((sollstundenWoche / solltageWoche) * 100) / 100;
		dialog.querySelector('[aria-label="u-bav-SollstundenTag"]').value = sollstundenTag;
	}
}

function updateBAVSollstundenTag(thisElement) {
	const dialog = document.getElementById('u-bav-dialog');
	const solltageWoche = parseFloat(dialog.querySelector('[aria-label="u-bav-SolltageWoche"]').value);
	const sollstundenTag = parseFloat(thisElement.value);
	if (solltageWoche > 0) {
		const sollstundenWoche = Math.round((sollstundenTag * solltageWoche) * 100) / 100;
		const sollstundenMonat = Math.round((sollstundenWoche * 4.35) * 100) / 100;
		dialog.querySelector('[aria-label="u-bav-SollstundenWoche"]').value = sollstundenWoche;
		dialog.querySelector('[aria-label="u-bav-SollstundenMonat"]').value = sollstundenMonat;
	}
}

function updateBAVSolltageWoche(thisElement) {
	const dialog = document.getElementById('u-bav-dialog');
	const sollstundenWoche = parseFloat(dialog.querySelector('[aria-label="u-bav-SollstundenWoche"]').value);
	const solltageWoche = parseFloat(thisElement.value);
	if (sollstundenWoche) {
		const sollstundenMonat = Math.round((sollstundenWoche * 4.35) * 100) / 100;
		const sollstundenTag = Math.round((sollstundenWoche / solltageWoche) * 100) / 100;
		dialog.querySelector('[aria-label="u-bav-SollstundenTag"]').value = sollstundenTag;
		dialog.querySelector('[aria-label="u-bav-SollstundenMonat"]').value = sollstundenMonat;
	}
}

export {
    ladeZeitregeln,
};
